/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Description_Export_Folder_HelpInputs */



/**
* | output |
* | --- |
* | "Select where to save your audio description files" |
*
* @param {Audio_Description_Export_Folder_HelpInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_description_export_folder_help = /** @type {((inputs?: Audio_Description_Export_Folder_HelpInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Description_Export_Folder_HelpInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Sélectionnez l'emplacement pour enregistrer vos fichiers de description audio")
	if (locale === "de") return /** @type {LocalizedString} */ ("Wählen Sie aus, wo Ihre Audiobeschreibungsdateien gespeichert werden sollen.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Seleziona dove salvare i file delle descrizioni audio")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Выберите место для сохранения файлов аудиоописания.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Seleccione dónde guardar sus archivos de descripción de audio")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("选择音频描述文件的保存位置")
	if (locale === "ja") return /** @type {LocalizedString} */ ("音声説明ファイルを保存する場所を選択してください")
	if (locale === "hi") return /** @type {LocalizedString} */ ("ऑडियो विवरण फ़ाइलों को सहेजने के लिए स्थान चुनें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Selecione onde salvar seus arquivos de audiodescrição.")
	return /** @type {LocalizedString} */ ("Select where to save your audio description files")
});